import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-wp-download-files-modal',
  templateUrl: './wp-download-files-modal.component.html',
  styleUrl: './wp-download-files-modal.component.css',
})
export class WpDownloadFilesModalComponent {
  @Input() attachmentModal: boolean = false;
  @Input() wpList: any = [];

  @Output() downloadFile = new EventEmitter<any>();
  @Output() closeDownlaodModal = new EventEmitter<boolean>();
  closeDownloadModal() {
    this.attachmentModal = false;
    this.closeDownlaodModal.emit(false);
  }
}
